export default __webpack_public_path__ + "static/media/3270.de7c51b0.png";